module.exports = __webpack_public_path__ + "static/hexowatch-logo-d7cff8d28129c78c68e21c2116ea3d90.svg";